console.log("The Nav height code can be reached!!!");

document.addEventListener("DOMContentLoaded", () => {
    //console.log("The Nav height code can be reached!!!");

    // Function to update the navigation height and set CSS variables
    function updateNavigationHeight(): void {
      const nav = document.querySelector(".navbar") as HTMLElement | null; 
      const navigationHeight = nav ? nav.offsetHeight : 0;
  
      // Set the CSS variable --top-margin with the navbar height
      document.documentElement.style.setProperty(
        "--top-margin",
        `${navigationHeight}px`
      );
    }
  
    // Initial call to set the values on page load
    updateNavigationHeight();
  
    // Update values on window resize
    window.addEventListener("resize", updateNavigationHeight);
  });
  